module.exports = __webpack_public_path__ + "media/images/pic/saska/cambridge-e188d487ac488c2ecd412f761e913f3c.png";